import { Trans, useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

import { theme, Typography } from '@zendesk/forethought-elements';

const PercentChangeTooltipContent = () => {
  const { t } = useTranslation('discover-tooltip');

  return (
    <Box
      sx={{
        padding: 2,
      }}
    >
      <Typography variant='font12'>
        <Box
          sx={{
            mb: 2,
          }}
        >
          <Trans
            components={{ bold: <strong /> }}
            i18nKey='percentChange.definition'
            ns='discover-tooltip'
          />
        </Box>
        <Box
          sx={{
            mb: 0.5,
          }}
        >
          <Typography color={theme.palette.colors.grey[800]} variant='font11'>
            {t('percentChange.exampleHeading')}
          </Typography>
        </Box>
        <Trans
          components={{ bold: <strong /> }}
          i18nKey='percentChange.example'
          ns='discover-tooltip'
        />
      </Typography>
    </Box>
  );
};

export default PercentChangeTooltipContent;
